module.exports = __webpack_public_path__ + "static/media/26UNRWA1.becf5a66.jpg";